import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const PLUGIN_CONFIG = enabledOn(PlatformSlug.MCATBooster)

export const isPluginAvailable = (slug?: PlatformSlug) => isFeatureAvailable(PLUGIN_CONFIG, slug)
